module.exports = __webpack_public_path__ + "img/ico_phmeter-54.378bab8f.svg";